<template>
  <b-container fluid>
    <b-row class="py-2">
      <b-col
        cols="auto"
        class="my-auto"
      >
        <span>
          รายการที่เลือก
        </span>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-input
          v-model="searchItemValue"
          placeholder="ค้นหาสินค้า"
          @input="itemSearchHandler"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table
          :items="itemsUse"
          :fields="fields"
          :is-busy="isBusy"
          sticky-header
          responsive
          show-empty
          empty-text="ไม่มีผลลัพธ์"
          class="item-invoice-table"
        >
          <template
            slot="price"
            slot-scope="data"
          >
            <b-row>
              <b-col cols="auto">
                <b-form-input
                  :ref="`lab-detail-input-price-${data.index}`"
                  v-model="itemsInput[data.index].price"
                  size="sm"
                  type="number"
                />
              </b-col>
              <!--              <b-col cols="6">-->
              <!--                <b-button-->
              <!--                  variant="warning"-->
              <!--                  @click="setDefaultPrice(data.item, data.index)"-->
              <!--                >-->
              <!--                  ราคาเริ่มต้น-->
              <!--                </b-button>-->
              <!--              </b-col>-->
            </b-row>
          </template>
          <template
            slot="quantity"
            slot-scope="data"
          >
            <b-form-input
              :ref="`lab-detail-quantity-${data.index}`"
              v-model="itemsInput[data.index].quantity"
              size="sm"
              type="number"
            />
          </template>
          <template
            slot="price"
            slot-scope="data"
          >
            {{ $numeral(data.item.price).format('0,0[.]00') }}
          </template>
          <template
            slot="totalPrice"
            slot-scope="data"
          >
            <b-form-input
              :value="$numeral((+data.item.price * +data.item.quantity).toFixed(2)).format('0,0[.]00')"
              size="sm"
              disabled
            />
          </template>
          <template
            slot="action"
            slot-scope="data"
          >
            <b-button
              variant="danger"
              @click="removeItemHandler(data.item.id)"
            >
              ลบ
            </b-button>
          </template>
        </b-table>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import { mapActions } from 'vuex';

  export default {
    name: "ItemInvoiceDetailTable",
    props: {
      items: {
        type: Array,
        default: () => []
      },
      isBusy: {
        type: Boolean,
        default: false
      },
      specieId: {
        type: Number,
        default: null,
      }
    },
    data() {
      return {
        fields: [
          { key: 'item_code', label: 'รหัสสินค้า'},
          { key: 'name', label: 'ชื่อสินค้า'},
          { key: 'price', label: 'ราคา'},
          { key: 'quantity', label: 'จำนวน'},
          { key: 'totalPrice', label: 'รวม'},
          { key: 'action', label: 'ACTIONS'},
        ],
        searchItemValue: '',
        itemsUse: [],
      }
    },
    computed: {
      itemsInput: {
        get() {
          return this.items
        },
        set(value) {
          this.$emit('update:items', value)
        },
      },
    },
    watch: {
      items(val) {
        this.itemsUse = val.filter(item => item.name.toLowerCase().includes(this.searchItemValue.toLowerCase()) || item.item_code.toLowerCase().includes(this.searchItemValue.toLowerCase()))
      }
    },
    mounted() {
      this.itemsUse = this.items
        .filter(item => item.name.toLowerCase().includes(this.searchItemValue.toLowerCase()) || item.item_code.toLowerCase().includes(this.searchItemValue.toLowerCase()))
    },

    methods: {
      ...mapActions({
        getTestPrice: 'Account/getTestPrice',
        getSetTestPrice: 'Account/getSetTestPrice',
      }),
      async removeItemHandler(id) {
        const confirm = await this.$swal.fire({
          title: 'ยืนยันการเอาสินค้าออก',
          text: "คุณต้องการนำสินค้าออกใช่หรือไม่",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'ลบ',
          cancelButtonText: 'ยกเลิก'
        })

        if (confirm.value) {
          this.itemsInput = this.itemsInput.filter(item => item.id !== id);
        }
      },
      itemSearchHandler() {
        this.itemsUse = this.items
          .filter(item => item.name.toLowerCase().includes(this.searchItemValue.toLowerCase()) || item.item_code.toLowerCase().includes(this.searchItemValue.toLowerCase()))
      },
      async setDefaultPrice(item, index) {
        this.$store.state.isLoading = true
        let price;
        if (item.set_test_id) {
          try {
            price = await this.getSetTestPrice({id: item.set_test_id, specieId: this.specieId})
          } catch (err) {
            await this.$swal.fire('เกิดข้อผิดพลาด', err.message, 'error')
            this.$store.state.isLoading = false
          }
        } else if (item.test_id) {
          try {
            price = await this.getTestPrice({id: item.test_id, specieId: this.specieId})
          } catch (err) {
            await this.$swal.fire('เกิดข้อผิดพลาด', err.message, 'error')
            this.$store.state.isLoading = false
          }
        }

        this.items[index].price = price
        this.$store.state.isLoading = false

      },
    },
  }
</script>

<style lang="scss" scoped>
  .item-invoice-table {

    height: 35rem;
    /*width: 45rem;*/
    width: 100%;
    border: 1px solid #6b757f;
  }
</style>
